import { nanoid } from 'nanoid';

import type { Workbench } from '../../workbench/entities/workbench';

/** Identity only in navigation. Actual cursor lookup belongs to the opened editor. */
export function openDocAtPerson(
  workbench: Workbench,
  docId: string,
  userId: string,
  inSplit = false
) {
  workbench.openDoc(
    { docId, mode: 'edgeless', presenceUserId: userId, refreshKey: nanoid(8) },
    inSplit ? { at: 'beside' } : undefined
  );
}
